// Category data for the Footer's "Concept Websites / Demonstrations" dropdowns.
import { CLINIC_LIST } from "../dental/dentalClinics";
import { REAL_ESTATE_AGENTS } from "../realestate/realEstateAgents";
import { EVENT_BUSINESSES } from "../events/eventBusinesses";

export const GOLD_JEWELRY = [
  { slug: "covo", href: "/covo-24k-gold-hk", label: "COVO 24K GOLD HK", badge: "Concept", color: "#C8A14A" },
  { slug: "helen", href: "/helen-jewelry-shop-concept", label: "Helen Jewelry Shop", badge: "Concept", color: "#C9A66B" },
  { slug: "typohuat", href: "/ty-po-huat-goldsmith-concept", label: "Ty Po Huat Goldsmith", badge: "Concept", color: "#B08D3E" },
  { slug: "mayfair", href: "/mayfair-goldsmith-concept", label: "Mayfair Goldsmith", badge: "Concept", color: "#C99B3E" },
  { slug: "rbjewelry", href: "/rb-jewelry-concept", label: "RB Jewelry", badge: "Concept", color: "#C97A46" },
  { slug: "cebugold", href: "/cebu-gold-pacific-concept", label: "Gold & Glitz (Cebu)", badge: "Concept Redesign", color: "#CBA23B" },
  { slug: "myrna", href: "/myrnas-jewelry-concept", label: "Myrna's Jewelry", badge: "Concept", color: "#D4AF37" },
  { slug: "agenciabelen", href: "/agencia-belen-pawnshop-concept", label: "Agencia Belen Pawnshop", badge: "Concept", color: "#E3B23C" },
  { slug: "pqjewelries", href: "/pq-jewelries-concept", label: "PQ Jewelries & Accessories", badge: "Concept", color: "#B98A2E" },
  { slug: "belcina", href: "/belcina-jewelry-concept", label: "Belciña Jewelry", badge: "Concept", color: "#C9A24A" },
  { slug: "jehannah", href: "/jehannah-goldsmith-concept", label: "Jehannah Goldsmith", badge: "Concept", color: "#C7A03C" },
];

export const DENTAL_CLINIC = CLINIC_LIST.map((c) => ({
  slug: c.slug,
  href: `/${c.slug}`,
  label: c.name,
  badge: "Concept",
  color: "#3DB6A6",
}));

export const CONSTRUCTION = [
  { slug: "ac-tajanlangit-construction-concept", href: "/ac-tajanlangit-construction-concept", label: "A.C. Tajanlangit Construction", badge: "Concept", color: "#B08D3E" },
  { slug: "megward-construction-concept", href: "/megward-construction-concept", label: "Megward Construction", badge: "Concept", color: "#D97757" },
  { slug: "g-uymatiao-jr-construction-concept", href: "/g-uymatiao-jr-construction-concept", label: "G. Uymatiao Jr. Construction", badge: "Concept", color: "#1D5B3A" },
  { slug: "alexis-construction-concept", href: "/alexis-construction-concept", label: "Alexis Construction", badge: "Concept", color: "#C81E2C" },
  { slug: "jra-home-builders-concept", href: "/jra-home-builders-concept", label: "JRA HOME Builders", badge: "Concept", color: "#C8102E" },
  { slug: "k-elman-construction-concept", href: "/k-elman-construction-concept", label: "K. Elman Construction", badge: "Concept", color: "#B3242A" },
  { slug: "rkd-plus-construction-concept", href: "/rkd-plus-construction-concept", label: "RKD PLUS Construction & Interiors", badge: "Concept", color: "#0B2545" },
  { slug: "algon-engineering-construction-concept", href: "/algon-engineering-construction-concept", label: "Algon Engineering Construction", badge: "Concept", color: "#F2B705" },
  { slug: "khan-kon-chi-construction-concept", href: "/khan-kon-chi-construction-concept", label: "Khan Kon Chi Construction", badge: "Concept", color: "#1652A8" },
  { slug: "egi-construction-concept", href: "/egi-construction-concept", label: "E.G. & I Construction Corporation", badge: "Concept", color: "#E0611C" },
  { slug: "ac-rivero-development-concept", href: "/ac-rivero-development-concept", label: "A.C. Rivero Development", badge: "Concept", color: "#B08A3E" },
  { slug: "constantin-design-build-concept", href: "/constantin-design-build-concept", label: "Constantin Design & Project Management", badge: "Concept", color: "#C9A97B" },
  { slug: "tuanson-construction-concept", href: "/tuanson-construction-concept", label: "Tuanson Construction", badge: "Concept", color: "#C9A227" },
  { slug: "cubeworx-builders-concept", href: "/cubeworx-builders-concept", label: "Cubeworx Builders & Development", badge: "Concept", color: "#E85D2A" },
  { slug: "dpx-negros-construction-concept", href: "/dpx-negros-construction-concept", label: "Dumaguete PhilX Condev (DPX)", badge: "Concept", color: "#0E5E5B" },
];

export const REAL_ESTATE = REAL_ESTATE_AGENTS.map((agent) => ({
  slug: agent.slug,
  href: `/${agent.slug}`,
  label: agent.name,
  badge: "Concept",
  color: agent.accent,
}));

const EVENT_COLORS = {
  hospitality: "#B4613D",
  creative: "#EE5E60",
  editorial: "#905D54",
  glamour: "#B87C4B",
  indoor: "#A4673D",
  outdoor: "#0B7B80",
  professional: "#17334A",
  catalogue: "#D54D35",
  "party-shop": "#F24D60",
  colorful: "#DF3E71",
};

export const WEDDING_EVENT = EVENT_BUSINESSES.map((business) => ({
  slug: business.slug,
  href: `/${business.slug}`,
  label: business.name,
  badge: "Concept",
  color: EVENT_COLORS[business.layout],
}));

export const LAW_ACCOUNTING = [
  { slug: "berguia-law-davao-concept", href: "/berguia-law-davao-concept", label: "Berguia Law", badge: "Concept", color: "#B98D4B" },
  { slug: "scale-documentation-makati-concept", href: "/scale-documentation-makati-concept", label: "SCALE Documentation Services", badge: "Concept", color: "#C2410C" },
  { slug: "meking-law-firm-concept", href: "/meking-law-firm-concept", label: "Meking Law Firm", badge: "Concept", color: "#B91C1C" },
  { slug: "gutierrez-legal-team-concept", href: "/gutierrez-legal-team-concept", label: "The Gutierrez Legal Team", badge: "Concept", color: "#DC2626" },
  { slug: "tlc-law-firm-mandaue-concept", href: "/tlc-law-firm-mandaue-concept", label: "TLC Law Firm", badge: "Concept", color: "#0F5C56" },
  { slug: "espiritu-associates-law-bacolod-concept", href: "/espiritu-associates-law-bacolod-concept", label: "Espiritu and Associates Law Office", badge: "Concept", color: "#1B4332" },
  { slug: "trenas-law-iloilo-concept", href: "/trenas-law-iloilo-concept", label: "Treñas Rubias Dela Cruz Lee-Trimañez & Associates", badge: "Concept", color: "#0B1F45" },
  { slug: "abo-penaranda-law-bgc-concept", href: "/abo-penaranda-law-bgc-concept", label: "Abo & Penaranda Law Firm", badge: "Concept Redesign", color: "#0F766E" },
  { slug: "kvp-cabahug-law-cebu-concept", href: "/kvp-cabahug-law-cebu-concept", label: "KVP Cabahug; Amigo-Escobar & Partners Law", badge: "Concept", color: "#A6522E" },
  { slug: "cpa-tax-bookkeeping-mandaluyong-concept", href: "/cpa-tax-bookkeeping-mandaluyong-concept", label: "CPA Tax & Bookkeeping Firm Co.", badge: "Concept", color: "#1D4ED8" },
  { slug: "judy-cabrera-accounting-concept", href: "/judy-cabrera-accounting-concept", label: "Judy M. Cabrera Accounting Services", badge: "Concept", color: "#DC2626" },
  { slug: "talaba-accounting-cebu-concept", href: "/talaba-accounting-cebu-concept", label: "R. Talaba Accounting Firm", badge: "Concept", color: "#3730A3" },
  { slug: "hico-janda-cpas-concept", href: "/hico-janda-cpas-concept", label: "Hico, Janda & Co., CPAs", badge: "Concept", color: "#1E3A5F" },
  { slug: "pso-accounting-group-concept", href: "/pso-accounting-group-concept", label: "PSO Accounting Group", badge: "Concept Redesign", color: "#059669" },
];

const futureCategory = (key, label) => ({
  key,
  label,
  items: [],
  emptyLabel: "Future category — no concept websites added yet.",
});

export const CONCEPT_CATEGORIES = [
  { key: "gold-jewelry", label: "Gold & Jewelry", items: GOLD_JEWELRY },
  { key: "dental-clinic", label: "Dental Clinic", items: DENTAL_CLINIC },
  { key: "construction", label: "Construction", items: CONSTRUCTION },
  { key: "real-estate-brokers", label: "Real Estate Brokers", items: REAL_ESTATE },
  { key: "wedding-event-venues", label: "Wedding & Event Venues", items: WEDDING_EVENT },
  { key: "law-accounting-consulting", label: "Law, Accounting & Consulting", items: LAW_ACCOUNTING },
  futureCategory("tour-diving-island-hopping", "Tours, Diving & Island Hopping"),
  futureCategory("aesthetic-dermatology-skin-clinics", "Aesthetic, Dermatology & Skin Clinics"),
];
